import { Tooltip } from '@mui/material';
import { TinyVariant } from '@shared/constants/components/tinyUtils';
import { IconName } from '../images/IconMap';
import Icons from '../images/Icons';
import SrOnlyText from '../text/SrOnlyText';
import { BoldTinyText, TinyRow, TinyText } from './CommonTinyStyles';

interface ITinyTagProps {
    title: string;
    value?: string | number;
    hideLabel?: boolean;
    tooltip?: string;
    icon?: IconName;
    iconSize?: number;
    variant?: TinyVariant;
}

export default function TinyTag({
    title,
    value,
    hideLabel,
    tooltip,
    icon,
    iconSize,
    variant = 'diminished',
}: Readonly<ITinyTagProps>) {
    const tag = (
        <TinyRow $variant={variant} title={hideLabel && !tooltip ? title : undefined}>
            {icon && <Icons weight="bold" name={icon} size={iconSize || 14} />}
            {value !== undefined && <BoldTinyText>{value}</BoldTinyText>}
            {hideLabel ? <SrOnlyText>{title}</SrOnlyText> : <TinyText>{title}</TinyText>}
        </TinyRow>
    );

    if (!tooltip) return tag;

    return (
        <Tooltip title={tooltip} arrow>
            {tag}
        </Tooltip>
    );
}
